import { atom } from 'jotai';

import { shouldShowFloatingActionMenuState } from './should-show-floating-action-menu.state';

/**
 * Base atom that controls whether the bulk edit sidebar is open.
 * The sidebar is opened manually from the floating action menu.
 */
const baseIsSidebarBulkEditOpenState = atom<boolean>(false);

/**
 * Derived atom that automatically closes the sidebar when no products are selected.
 * This ensures the sidebar closes when the selection is cleared, without needing useEffect.
 */
export const isSidebarBulkEditOpenState = atom<boolean, [boolean], void>(
  (get) => {
    const shouldShowFloatingMenu = get(shouldShowFloatingActionMenuState);
    const isOpen = get(baseIsSidebarBulkEditOpenState);
    // Automatically close sidebar if no products are selected
    return shouldShowFloatingMenu ? isOpen : false;
  },
  (get, set, value: boolean) => {
    const shouldShowFloatingMenu = get(shouldShowFloatingActionMenuState);
    // Only allow opening if there are selected products
    if (value && !shouldShowFloatingMenu) {
      return;
    }
    set(baseIsSidebarBulkEditOpenState, value);
  }
);
